module.exports = __webpack_public_path__ + "static/media/interview.7bfbe9bf.PNG";